import { get, getOr } from 'lodash/fp';
import { LiveChat } from '@ahmdigital/ui';
import { MutableRefObject } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import getMessageUsButtonImage from '@ahmdigital/logic/lib/utils/get-message-us-button-image';
// @ts-expect-error - Automatic, Please fix when editing this file
import liveChatActions from '@ahmdigital/livechat/lib/actions';

import constants from '../../ahm-constants';
import device from '../../utils/device';
import liveChatConfig from '../../utils/livechat';
import messageUsRegularImage from './images/message-us-regular.svg';
import RequestACall from '../../components/request-a-call';
import selectLastViewedProduct from '../../selectors/select-last-viewed-product';
import styles from './styles.module.sass';
import useIntersectionObserver from '../../hooks/use-intersection-observer';
import useIsAfterHydration from '../../hooks/use-is-after-hydration';
import useMessageUs from './utils/use-message-us';
import useRequestACall from './utils/use-request-a-call';
import useViewportValue from '../../utils/use-viewport-value';

type FooterLinksProps = {
  cmsAnnouncementBannerRef?: MutableRefObject<HTMLDivElement | null>;
  footerRef: MutableRefObject<HTMLDivElement | null>;
};

const FooterLinks = ({ footerRef, cmsAnnouncementBannerRef }: FooterLinksProps) => {
  const { isAdjusted, adjustedHeight } = useSelector(get('footer.adjustFooterLinks'));
  const liveChatStatus = useSelector(get('livechat.status'));
  const lastViewedProduct = useSelector((state) => selectLastViewedProduct(state));
  const dispatch = useDispatch();
  const { entry: observer } = useIntersectionObserver(footerRef);
  const isIntersectingWithFooter = getOr(false, 'isIntersecting', observer);
  const pathname = get('asPath', useRouter());
  const isAfterHydration = useIsAfterHydration();
  const isTabletOrMobile = useViewportValue(device.isTabletOrMobile);
  // Any page specific styling for the FooterLinks is only applied when the FooterLinks
  // component is not intersecting with the page footer
  const isFooterAdjusted = isAdjusted && !isIntersectingWithFooter;
  const adjustedHeightStyle =
    isFooterAdjusted && adjustedHeight && !isTabletOrMobile
      ? // TODO: AP-2305 clean this up once onetrust is implemented
        { transform: `translateY(calc(-1 * var(--cookie-disclaimer-height, ${adjustedHeight}px)))` }
      : undefined;

  const messagingImage = getMessageUsButtonImage(constants.URLS.FILES);
  const showMessageUs = useMessageUs(pathname);
  const canShowRequestACall = useRequestACall(pathname, lastViewedProduct);

  return (
    <div className={styles.footerLinks} style={adjustedHeightStyle}>
      <div className={styles.autoLeft}>
        {isAfterHydration && canShowRequestACall && (
          <RequestACall cmsAnnouncementBannerRef={cmsAnnouncementBannerRef} />
        )}
      </div>
      {isAfterHydration && showMessageUs && (
        <div className={styles.liveChat}>
          <LiveChat
            image={{
              alt: 'Speech bubble saying “Message us”',
              src: messagingImage?.webUrl || messageUsRegularImage.src,
            }}
            launchChatWindow={() => liveChatActions.launch(liveChatConfig)(dispatch)}
            status={liveChatStatus}
          />
        </div>
      )}
    </div>
  );
};

export default FooterLinks;
